import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeadBulkUploadService {

  constructor(private ws: PostmethodService) { }

  bulkUpload(formData: FormData) {
    return this.ws.wsPostFile(formData, environment.baseUrl + "/lead/bulkCreateLead");
  }
  
  getSampleData(){
    return this.ws.wsGet(environment.baseUrl + "/lead/bulkMasterData");
  }
}
